module.exports = __webpack_public_path__ + "img/ti.0b62c50c.jpg";